import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import PricingStructureSelect from "legacy/PricingStructureSelect"
import {
  afterSetState,
  centsToDollars,
  centsToDollarsRaw,
  dollarsToCents,
  handleInputChange,
  isPresent,
  objectKeysToSnakeCase,
  parseJSONError,
  safePercentageDecimal,
} from "legacy/helpers.es6"
import Availability from "legacy/new-reservation-form/Availability"
import ItinerarySection from "legacy/new-reservation-form/ItinerarySection"
import PreservedRateModalButton from "legacy/preserved_rates_table/PreservedRateModalButton"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) is loaded globally, not via an import
// Note: $context is a global object containing configuration and context values

class Quote extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: this.props.page,
      arrival: this.props.arrival,
      departure: this.props.departure || undefined,
      spaceType: this.props.spaceType,
      loa: this.props.loa || undefined,
      beam: this.props.beam || undefined,
      isCustomBillingSet: this.props.isCustomBillingSet || false,
      isRateApplied: this.props.isRateApplied || false,
      rate: this.props.rate,
      rateType: this.props.rateType,
      loadingPrice: false,
      totalPrice: 0,
      preservedRates: [],
      priceErrorMessage: null,
      availabilityData: null,
      availabilityErrorMessage: null,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleArrivalChange = this.handleArrivalChange.bind(this)
    this.handleDepartureChange = this.handleDepartureChange.bind(this)
    this.handleRateInputChange = this.handleRateInputChange.bind(this)
    this.updateParent = this.updateParent.bind(this)
    this.refetchData = this.refetchData.bind(this)
    this.calculatePrice = _.debounce(this.calculatePrice.bind(this), 200)
    this.getAvailability = _.debounce(this.getAvailability.bind(this), 100)
    this.createWaitlist = this.createWaitlist.bind(this)
    this.changeRateType = this.changeRateType.bind(this)
    this.savedOrCustomRateApplied = this.savedOrCustomRateApplied.bind(this)
    this.formatTotalPrice = this.formatTotalPrice.bind(this)
    this.priceEstimateText = this.priceEstimateText.bind(this)
    this.calculatePriceParams = this.calculatePriceParams.bind(this)
    this.rateEmptyState = this.rateEmptyState.bind(this)
    this.installmentRateOptions = this.installmentRateOptions.bind(this)
    this.customRateForm = this.customRateForm.bind(this)
  }

  handleInputChange(e) {
    handleInputChange(this, e)
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
  }

  handleArrivalChange(date) {
    this.setState({ arrival: moment(date, "MM/DD/YYYY").format("YYYY-MM-DD") })
    afterSetState(this.updateParent)
    afterSetState(this.refetchData)
  }

  handleDepartureChange(date) {
    this.setState({
      departure: moment(date, "MM/DD/YYYY").format("YYYY-MM-DD"),
    })
    afterSetState(this.updateParent)
    afterSetState(this.refetchData)
  }

  updateParent() {
    this.props.updateParentState({
      rate: this.state.rate,
      isRateApplied: this.state.isRateApplied,
      isCustomBillingSet: this.state.isCustomBillingSet,
      arrival: this.state.arrival,
      departure: this.state.departure,
      spaceType: this.state.spaceType,
      rateType: this.state.rateType,
      loa: this.state.loa,
      beam: this.state.beam,
    })
  }

  changeRateType(value) {
    const namedRate = _.find(
      this.props.rateOptions.namedRates,
      (rate) => rate.id.toString() === value
    )
    let state = {}
    if (namedRate) {
      state = {
        rateType: value,
        isRateApplied: true,
        isCustomBillingSet: false,
        rate: {
          ...namedRate,
          amount: namedRate.amount ? centsToDollarsRaw(namedRate.amount) : 0,
          taxRate: namedRate.taxRate
            ? safePercentageDecimal(namedRate.taxRate)
            : 0.0,
        },
      }
    } else if (value === "nightly") {
      state = {
        rateType: value,
        isRateApplied: false,
        isCustomBillingSet: false,
        spaceType: this.props.marina.spaceTypes.includes(this.state.spaceType)
          ? this.state.spaceType
          : this.props.marina.spaceTypes[0],
        rate: {
          id: null,
          name: null,
          pricingStructure: "per_month",
          billingCycle: "first_of_month",
          amount: 0,
          taxRate: 0.0,
        },
      }
    } else {
      state = {
        rateType: value,
        isRateApplied: false,
        isCustomBillingSet: true,
        rate: {
          id: null,
          name: null,
          pricingStructure: "per_month",
          billingCycle: "first_of_month",
          amount: 0,
          taxRate: 0.0,
        },
      }
    }

    this.setState(state)
    this.props.updateParentState(state)
    afterSetState(this.calculatePrice)
  }

  createWaitlist() {
    const params = {
      first_day: moment(this.state.arrival).format("MM/DD/YYYY"),
      last_day: moment(this.state.departure).format("MM/DD/YYYY"),
      length_overall: this.state.loa || "",
      beam: this.state.beam || "",
    }
    const urlParams = new URLSearchParams(params).toString()

    window.location.href = $context.waitlistPath + "?" + urlParams
  }

  calculatePriceParams() {
    const params = {
      check_in_date: this.state.arrival,
      check_out_date: this.state.departure,
      requested_space_type: this.state.spaceType,
      length_overall: this.state.loa * 12,
      beam: this.state.beam * 12,
    }
    if (this.savedOrCustomRateApplied()) {
      const rateParams = {
        ...this.state.rate,
        amount: dollarsToCents(parseFloat(this.state.rate.amount)),
        taxRate: this.state.rate.taxRate
          ? parseFloat(this.state.rate.taxRate) / 100
          : 0.0,
      }
      params.rate = _.mapKeys(rateParams, objectKeysToSnakeCase)
    } else {
      params.electrical_rate_id = this.state.electricId
      params.discounts = JSON.stringify(this.state.discounts)
    }
    return params
  }

  savedOrCustomRateApplied() {
    return this.state.isRateApplied || this.state.isCustomBillingSet
  }

  refetchData() {
    this.getAvailability()
    this.calculatePrice()
  }

  formatTotalPrice() {
    if (this.state.totalPrice === "--") {
      return this.state.totalPrice
    } else {
      return centsToDollars(this.state.totalPrice)
    }
  }

  priceEstimateText() {
    return "Price Estimate"
  }

  calculatePrice() {
    if (this.state.arrival && this.state.departure) {
      this.setState({
        loadingPrice: true,
        priceErrorMessage: null,
        billingDisplayText: null,
      })
      $.post(
        $context.calculatePricePath,
        this.calculatePriceParams(),
        (data) => {
          if (isPresent(data.Dock)) {
            data = data.Dock
          } else if (isPresent(data.Mooring)) {
            data = data.Mooring
          } else if (isPresent(data.Storage)) {
            data = data.Storage
          }
          this.setState({
            charges: data.breakdown,
            totalPrice: data.total,
            loadingPrice: false,
            billingDisplayText: data.billing_display_text,
            monthlyCharges: data.monthly_charges,
            monthlyPrice: data.monthly_price,
            preservedRates: data.preserved_rates,
          })
        }
      ).fail((data) => {
        const response = parseJSONError(data.responseText, "marinaError")
        this.setState({
          priceErrorMessage:
            response || "There was an error calculating the price.",
          loadingPrice: false,
          billingDisplayText: null,
        })
      })
    } else {
      this.setState({
        loadingPrice: false,
        priceErrorMessage: null,
        billingDisplayText: null,
        totalPrice: 0,
        preservedRates: [],
      })
    }
  }

  getAvailability() {
    if (this.state.arrival && this.state.departure) {
      const availabilityParams = {
        check_in_date: this.state.arrival,
        check_out_date: this.state.departure,
        requested_space_type: this.state.spaceType,
      }
      this.setState({
        loadingAvailability: true,
        availabilityErrorMessage: null,
      })
      $.post($context.availabilityPath, availabilityParams, (data) => {
        this.setState({ loadingAvailability: false, availabilityData: data })
      }).fail((data) => {
        const response =
          parseJSONError(data.responseText) ||
          "An error occurred while trying to calculate availability."
        this.setState({
          loadingAvailability: false,
          availabilityErrorMessage: response,
        })
      })
    }
  }

  handleRateInputChange(event) {
    const target = event.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const names = target.name.split(".")

    this.setState({ rate: { ...this.state.rate, [names[0]]: value } })
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
  }

  rateEmptyState() {
    if (this.props.rates && this.props.rates.length > 0) return null

    return (
      <div className="mb-4">
        To create a reusable Installment rate, visit{" "}
        <a className="font-medium" href={$context.pricingPath}>
          Account &gt; Pricing
        </a>
        .
      </div>
    )
  }

  installmentRateOptions() {
    if (this.props.rateOptions.namedRates.length === 0) return null

    return (
      <optgroup label="Installment Rates">
        {_.map(this.props.rateOptions.namedRates, (rate) => (
          <option key={rate.id} value={rate.id}>
            {rate.name}
          </option>
        ))}
      </optgroup>
    )
  }

  customRateForm() {
    return (
      <div>
        <div className="row">
          <PricingStructureSelect
            pricingStructure={
              this.state.rate.pricingStructure ||
              _.flatten(_.values(this.props.rateOptions.pricingStructures))[0]
                .value
            }
            pricingStructures={this.props.rateOptions.pricingStructures}
            handleInputChange={this.handleRateInputChange}
          />
        </div>
        <div className="row form-row">
          <div className="col-xs-6">
            <FormGroup
              inputType="currency"
              label="Rate"
              name="amount"
              value={this.state.rate.amount > 0 ? this.state.rate.amount : ""}
              onChange={this.handleRateInputChange}
            />
          </div>
          <div className="col-xs-6">
            <FormGroup
              inputType="percentage"
              label="Tax"
              name="taxRate"
              value={this.state.rate.taxRate}
              onChange={this.handleRateInputChange}
            />
          </div>
        </div>
        {this.rateEmptyState()}
      </div>
    )
  }

  render() {
    return (
      <div className="row form-row">
        <div className="col-sm-9">
          <div className="paper-page mb-4">
            <h3 className="mb-4 mt-0 font-semibold">Itinerary</h3>
            <ItinerarySection
              arrival={this.state.arrival}
              departure={this.state.departure}
              spaceType={this.state.spaceType}
              spaceTypes={
                this.savedOrCustomRateApplied()
                  ? this.props.marina.installmentSpaceTypes
                  : this.props.marina.spaceTypes
              }
              handleInputChange={this.handleInputChange}
              handleArrivalChange={this.handleArrivalChange}
              handleDepartureChange={this.handleDepartureChange}
              isTransient={!this.savedOrCustomRateApplied()}
              disabledRevenueCategory
            />

            <div className="row form-row">
              <div className="col-sm-4 col-xs-6">
                <FormGroup
                  inputType="feet"
                  label="LOA"
                  name="loa"
                  value={this.state.loa}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-sm-4 col-xs-6">
                <FormGroup
                  inputType="feet"
                  label="Beam"
                  name="beam"
                  value={this.state.beam}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="paper-page">
            <h3 className="mt-0 font-semibold">
              Availability
              <a
                className="text-muted float-right px-2"
                href={`${$context.managePath}/settings/space_groups`}
              >
                <i
                  className="fa-kit fa-cog"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Configure space group settings"
                />
              </a>
            </h3>

            {this.state.availabilityErrorMessage && (
              <div className="text-muted">
                {this.state.availabilityErrorMessage}
              </div>
            )}
            <Availability
              loading={this.state.loadingAvailability}
              data={this.state.availabilityData}
            />
          </div>
        </div>

        <div className="col-sm-3">
          <div className="paper-page p-4">
            <div>
              <FormGroup
                inputType="select"
                value={this.state.rateType}
                name="rateType"
                onChange={(event) => {
                  this.changeRateType(event.target.value)
                }}
              >
                <optgroup label="Default Nightly Rates">
                  <option key="nightly" value="nightly">
                    Default rates
                  </option>
                </optgroup>
                {this.installmentRateOptions()}
                <optgroup label="Custom Rate">
                  <option key="custom_installment" value="custom_installment">
                    Enter a custom rate
                  </option>
                </optgroup>
              </FormGroup>
              {this.state.isCustomBillingSet && this.customRateForm()}
            </div>

            <div
              className="rounded p-4 text-center"
              style={{ backgroundColor: "#f8fafc" }}
            >
              {this.state.loadingPrice && (
                <div className="h4">
                  <i className="fa-kit fa-spinner fa-spin text-muted" />
                </div>
              )}
              {this.state.priceErrorMessage && (
                <div className="text-danger">
                  {this.state.priceErrorMessage}
                </div>
              )}
              {!this.state.loadingPrice && (
                <h2 className="mb-0 font-semibold text-teal-700">
                  {this.formatTotalPrice()}
                </h2>
              )}
              <h4 className="mt-3 font-semibold">{this.priceEstimateText()}</h4>
              <PreservedRateModalButton
                preservedRates={this.state.preservedRates}
                fullWidth={true}
              />
            </div>

            <div className="mt-4">
              <LegacyButton
                type="primary"
                className="mb-4 w-full"
                onClick={this.props.goToContacts}
              >
                Create Reservation
              </LegacyButton>

              <LegacyButton
                type="secondary"
                icon="fa-list"
                className="w-full"
                onClick={this.createWaitlist}
              >
                Add to Waitlist
              </LegacyButton>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Quote.propTypes = {
  page: PropTypes.string,
  arrival: PropTypes.string.isRequired,
  departure: PropTypes.string,
  spaceType: PropTypes.string.isRequired,
  loa: PropTypes.number,
  beam: PropTypes.number,
  isCustomBillingSet: PropTypes.bool,
  isRateApplied: PropTypes.bool,
  rate: PropTypes.object,
  rateType: PropTypes.string.isRequired,
  marina: PropTypes.shape({
    spaceTypes: PropTypes.array.isRequired,
    installmentSpaceTypes: PropTypes.array,
  }).isRequired,
  rateOptions: PropTypes.shape({
    namedRates: PropTypes.array.isRequired,
    pricingStructures: PropTypes.object.isRequired,
  }).isRequired,
  updateParentState: PropTypes.func.isRequired,
  goToContacts: PropTypes.func.isRequired,
  rates: PropTypes.array,
}

export default Quote
